import { getPermissions, hasPermission } from "../../utilis/permissionStorage";
import React, { Component } from "react";
import Paginations from "../GenericComponents/Pagination";
import {
  get_ApiManager,
  search_ApiManager,
  view_ApiManager,
} from "../ApiManager/ApiManager";
import { apiUrl } from "../ApiManager/AxiosHeaders";
import swal from "sweetalert";
import { Sorting } from "../GenericComponents/SortTables";
import { user_role } from "../../utilis/appStatus";
import {
  makeHrAdmin,
  makeUserTeamLead,
  removeHrAdmin,
  bulkUpdateUserIp,
} from "../Services/apiServices";
import {
  MODULE_PAGE_SHELL_STYLE,
  TASK_PAGE_SHELL_CLASS,
} from "../TaskManagement/workspaceConstants";
import AccountsHeader from "./AccountsHeader";
import AccountsTable from "./AccountsTable";
import AccountsTableSkeleton from "./AccountsTableSkeleton";
import AccountsSearchFilters from "./AccountsSearchFilters";
import AccountsExportBar from "./AccountsExportBar";
import AddAccountModal from "./AddAccountModal";
import EditAccountModal from "./EditAccountModal";
import BulkIpToolbar from "./BulkIpToolbar";
import BulkIpModal from "./BulkIpModal";
import { EMPTY_ACCOUNTS_FILTERS } from "./useAccountsFilters";
import "../../styles/tailwind.css";
import "./accounts.css";

function isTeamLeadUser(user) {
  const value =
    user?.is_team_lead ??
    user?.team_lead ??
    user?.teamlead ??
    user?.isTeamLead ??
    0;
  return value === true || value === 1 || value === "1";
}

function isActiveUser(user) {
  return user?.activestatus === "Active" || user?.activestatus === 1;
}

function isHrAdminUser(user) {
  return user?.hr_admin === 1 || user?.hr_admin === "1" || user?.hr_admin === true;
}

class ViewAccounts extends Component {
  constructor(props) {
    super(props);
    var permissions = getPermissions();
    this.state = {
      loading: false,
      savingTeamLeadId: null,
      savingStatusId: null,
      savingHrAdminId: null,
      saving2faResetId: null,
      allUsers: [],
      totalItem: "",
      perItem: "",
      currentPage: 1,
      lastPage: "",
      perPage: 10,
      search: "",
      order: "ASC",
      sortColumn: "",
      participants: [],
      allBranch: [],
      allPermissions: permissions,
      branch: "",
      headers: [
        { title: "#", dataKey: "index", align: "text-center", key: 1 },
        { title: "Name", dataKey: "name", key: 2 },
        { title: "Role", dataKey: "role", align: "text-center", key: 3 },
        {
          title: "Branch",
          dataKey: "branchname",
          align: "text-center",
          key: 4,
        },
        {
          title: "Status",
          dataKey: "activestatus",
          align: "text-center",
          key: 5,
        },
        {
          title: "IP Check",
          dataKey: "ip_check",
          align: "text-center",
          key: 6,
        },
        { title: "Mobile", dataKey: "mobile", align: "text-center", key: 7 },
        {
          title: "Team Lead",
          dataKey: "is_team_lead",
          align: "text-center",
          key: 8,
        },
        {
          title: "HR Admin",
          dataKey: "hr_admin",
          align: "text-center",
          key: 9,
        },
        {
          title: "Actions",
          dataKey: "actions",
          align: "text-center",
          key: 10,
          sortable: false,
        },
      ],
      status: "",
      draft: { ...EMPTY_ACCOUNTS_FILTERS },
      showAddAccountModal: false,
      editAccountModal: {
        open: false,
        userId: null,
        mode: "edit",
      },
      selectedUserIds: [],
      bulkIpLoading: false,
      showBulkIpModal: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getUsers();
    this.getAllUsers();
    this.getAgents();

    const params = new URLSearchParams(window.location.search);
    if (params.get("action") === "add") {
      this.setState({ showAddAccountModal: true });
      window.history.replaceState({}, "", "/accounts/view-accounts");
    }
    const editAction = params.get("action");
    const editId = params.get("id");
    if ((editAction === "edit" || editAction === "view") && editId) {
      this.setState({
        editAccountModal: {
          open: true,
          userId: editId,
          mode: editAction === "view" ? "detail" : "edit",
        },
      });
      window.history.replaceState({}, "", "/accounts/view-accounts");
    }
  }

  getAgents() {
    let url = "getAgentsByOffice";
    get_ApiManager(
      "",
      url,
      (res) => {
        console.log("agents", res);
        this.setState({ allBranch: res.data.data });
      },
      (err) => {
        console.log(err);
      },
    );
  }

  getAllUsers = () => {
    let url = "allUsers";
    view_ApiManager(
      url,
      0,
      0,
      (res) => {
        console.log("Get all Users", res);
        const participants = res.data.data.map((user) => ({
          label: user.name,
          value: user.id,
        }));
        this.setState({ participants: participants });
      },
      (err) => {
        console.log(err);
      },
    );
  };

  async getUsers() {
    this.setState({ loading: true });
    let currentPage = this.state.currentPage;
    let perPage = this.state.perPage;
    let url = "getAllUsers";
    view_ApiManager(
      url,
      currentPage,
      perPage,
      (res) => {
        console.log("Get All Users", res);
        this.setState({
          allUsers: res.data.data["data"],
          loading: false,
          totalItem: res.data.data["total"],
          perPage: res.data.data["per_page"],
          lastPage: res.data.data["last_page"],
          perItem: res.data.data["data"].length,
        });
      },
      (err) => {
        this.setState({ loading: false });
        console.log(err);
      },
    );
  }

  handleOpenAddAccount = () => {
    this.setState({ showAddAccountModal: true });
  };

  handleCloseAddAccount = () => {
    this.setState({ showAddAccountModal: false });
  };

  handleAddAccountSuccess = () => {
    this.getUsers();
    this.getAllUsers();
  };

  handleOpenEditAccount = (userId) => {
    this.setState({
      editAccountModal: { open: true, userId, mode: "edit" },
    });
  };

  handleOpenViewAccount = (userId) => {
    this.setState({
      editAccountModal: { open: true, userId, mode: "detail" },
    });
  };

  handleCloseEditAccount = () => {
    this.setState({
      editAccountModal: { open: false, userId: null, mode: "edit" },
    });
  };

  handleEditAccountSuccess = () => {
    this.getUsers();
    this.getAllUsers();
  };

  handleToggleUserSelection = (userId, checked) => {
    this.setState((prev) => {
      const id = String(userId);
      const next = new Set((prev.selectedUserIds || []).map(String));
      if (checked) next.add(id);
      else next.delete(id);
      return { selectedUserIds: [...next] };
    });
  };

  handleToggleAllUsers = (checked) => {
    this.setState((prev) => {
      const pageIds = (prev.allUsers || []).map((user) => String(user.id));
      if (!checked) {
        const next = new Set((prev.selectedUserIds || []).map(String));
        pageIds.forEach((id) => next.delete(id));
        return { selectedUserIds: [...next] };
      }
      const next = new Set([
        ...(prev.selectedUserIds || []).map(String),
        ...pageIds,
      ]);
      return { selectedUserIds: [...next] };
    });
  };

  handleClearUserSelection = () => {
    this.setState({ selectedUserIds: [] });
  };

  runBulkIpAction = async ({ action, ip_address = "" }) => {
    const userIds = (this.state.selectedUserIds || []).map((id) => Number(id));
    if (!userIds.length) {
      swal("No users selected", "Select at least one account first.", "info");
      return;
    }

    this.setState({ bulkIpLoading: true });
    try {
      const result = await bulkUpdateUserIp({
        user_ids: userIds,
        action,
        ip_address,
      });

      if (result?.error || result?.data?.error) {
        swal("Unable to update", result.error || result.data.error, "error");
        return;
      }

      swal(
        "Updated",
        result?.message || "IP settings updated successfully.",
        "success",
      );
      this.setState({
        showBulkIpModal: false,
        selectedUserIds: [],
      });
      this.getUsers();
    } catch (error) {
      swal(
        "Unable to update",
        error?.message || "Unable to update IP settings.",
        "error",
      );
    } finally {
      this.setState({ bulkIpLoading: false });
    }
  };

  handleBulkEnableIp = async () => {
    const count = this.state.selectedUserIds.length;
    const willContinue = await swal({
      title: "Enable IP check?",
      text: `Turn on IP restriction for ${count} selected account${count === 1 ? "" : "s"}?`,
      icon: "info",
      buttons: ["Cancel", "Enable"],
    });
    if (!willContinue) return;
    this.runBulkIpAction({ action: "enable" });
  };

  handleBulkDisableIp = async () => {
    const count = this.state.selectedUserIds.length;
    const willContinue = await swal({
      title: "Disable IP check?",
      text: `Turn off IP restriction for ${count} selected account${count === 1 ? "" : "s"}?`,
      icon: "warning",
      buttons: ["Cancel", "Disable"],
    });
    if (!willContinue) return;
    this.runBulkIpAction({ action: "disable" });
  };

  handleBulkClearIps = async () => {
    const count = this.state.selectedUserIds.length;
    const willContinue = await swal({
      title: "Clear stored IPs?",
      text: `Remove saved IP addresses for ${count} selected account${count === 1 ? "" : "s"}?`,
      icon: "warning",
      buttons: ["Cancel", "Clear"],
      dangerMode: true,
    });
    if (!willContinue) return;
    this.runBulkIpAction({ action: "clear_ips" });
  };

  handleBulkIpModalSubmit = ({ action, ip_address }) => {
    this.runBulkIpAction({ action, ip_address });
  };

  deleteUser = (delete_id, name) => {
    swal({
      title: "Are you sure?",
      text: "You will not be able to recover (" + name + ")",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (!willDelete) return;

      apiUrl
        .get(`deleteUser/${delete_id}`)
        .then(() => {
          swal("User (" + name + ") deleted successfully", {
              icon: "success",
            });
            this.getUsers();
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };

  handleResetTwoFactor = async (user) => {
    if (!user?.id || this.state.saving2faResetId) return;

    const willContinue = await swal({
      title: "Reset 2FA?",
      text: `${user.name} will set up 2FA again at next sign-in. Confirm you verified their identity.`,
      icon: "warning",
      buttons: ["Cancel", "Reset 2FA"],
      dangerMode: true,
    });

    if (!willContinue) return;

    this.setState({ saving2faResetId: user.id });
    try {
      const res = await apiUrl.post(`2fa/admin-reset/${user.id}`);
      swal("2FA reset", res.data?.message || "Done.", "success");
      this.getUsers();
    } catch (err) {
      swal(
        "Could not reset",
        err?.response?.data?.message || "Please try again.",
        "error"
      );
    } finally {
      this.setState({ saving2faResetId: null });
    }
  };

  handleToggleTeamLead = async (user) => {
    if (!user?.id || this.state.savingTeamLeadId) return;

    const currentlyTeamLead = isTeamLeadUser(user);
    const actionLabel = currentlyTeamLead
      ? "Remove Team Lead"
      : "Make Team Lead";

    const willContinue = await swal({
      title: currentlyTeamLead ? "Remove Team Lead?" : "Assign Team Lead?",
      text: currentlyTeamLead
        ? `Remove team lead from ${user.name}?`
        : `Make ${user.name} a team lead?`,
      icon: "info",
      buttons: ["Cancel", actionLabel],
    });

    if (!willContinue) return;

    this.setState({ savingTeamLeadId: user.id });
    try {
      const result = await makeUserTeamLead(user.id);
      if (result?.error) {
        swal("Unable to update", result.error, "error");
        return;
      }

      const nextValue = currentlyTeamLead ? 0 : 1;
      this.setState((prev) => ({
        allUsers: prev.allUsers.map((item) =>
          String(item.id) === String(user.id)
            ? {
                ...item,
                is_team_lead: nextValue,
                team_lead: nextValue,
              }
            : item,
        ),
      }));

      try {
        const loggedInUser = JSON.parse(localStorage.getItem("user") || "null");
        if (loggedInUser && String(loggedInUser.id) === String(user.id)) {
          localStorage.setItem(
            "user",
            JSON.stringify({
              ...loggedInUser,
              is_team_lead: nextValue,
              team_lead: nextValue,
            }),
          );
        }
      } catch (storageError) {
        console.error("Failed to update logged-in user team lead flag", storageError);
      }

      swal(
        "Updated",
        result?.message ||
          (currentlyTeamLead
            ? `${user.name} is no longer a team lead.`
            : `${user.name} is now a team lead.`),
        "success",
      );
    } catch (error) {
      swal(
        "Unable to update",
        error?.message || "Unable to update team lead.",
        "error",
      );
    } finally {
      this.setState({ savingTeamLeadId: null });
    }
  };

  handleToggleStatus = (user) => {
    if (!user?.id || this.state.savingStatusId) return;

    const isActive = isActiveUser(user);
    const url = isActive ? "deactivateUser" : "activateUser";

    this.setState({ savingStatusId: user.id });
    get_ApiManager(
      user.id,
      url,
      (res) => {
        if (res.data.error) {
          swal(" ", res.data.error, "error");
        } else {
          swal("Success!", res.data.message, "success");
          this.getUsers();
        }
        this.setState({ savingStatusId: null });
          },
          (err) => {
            console.log(err);
        this.setState({ savingStatusId: null });
      },
    );
  };

  handleToggleHrAdmin = async (user) => {
    if (!user?.id || this.state.savingHrAdminId) return;

    const isHrAdmin = isHrAdminUser(user);
    this.setState({ savingHrAdminId: user.id });

    try {
      const result = isHrAdmin
        ? await removeHrAdmin(user.id)
        : await makeHrAdmin(user.id);

      if (result?.error) {
        swal({ text: result.error, icon: "warning", dangerMode: true });
        return;
      }

      swal({ text: result.message, icon: "success", dangerMode: false });
      this.getUsers();
    } catch (error) {
      swal(
        "Unable to update",
        error?.message || "Unable to update HR admin status.",
        "error",
      );
    } finally {
      this.setState({ savingHrAdminId: null });
    }
  };

  handleCallback = (i, perPage) => {
    window.scrollTo(0, 0);
    if (this.state.search == "") {
      if (perPage && perPage != "") {
        this.setState({ perPage: perPage, currentPage: 1 }, () => {
          this.getUsers();
        });
      } else {
        this.setState({ currentPage: i }, () => {
          this.getUsers();
        });
      }
    } else {
      if (perPage && perPage != "") {
        this.setState({ perPage: perPage, currentPage: 1 }, () => {
          this.handleSearchCallback(this.state.search);
        });
      } else {
        this.setState({ currentPage: i }, () => {
          this.handleSearchCallback(this.state.search);
        });
      }
    }
  };

  sorting = (col) => {
    if (col === "actions") return;
    const sortResult = Sorting(this.state.allUsers, col, this.state.order);
    this.setState({
      order: sortResult[0],
      allUsers: sortResult[1],
      sortColumn: col,
    });
  };

  handleDraftChange = (draft) => {
    this.setState({ draft });
  };

  handleApplyFilters = () => {
    this.setState({ currentPage: 1 }, () => {
      const { draft } = this.state;
      this.handleSearchCallback(
        draft.names,
        draft.country,
        draft.roleId,
        draft.branchName,
        draft.status,
      );
    });
  };

  handleResetFilters = () => {
    this.setState(
      {
        draft: { ...EMPTY_ACCOUNTS_FILTERS },
        search: "",
        name: null,
        role: null,
        country: null,
        branch: null,
        status: null,
        currentPage: 1,
      },
      () => this.getUsers(),
    );
  };

  handleRemoveFilterChip = (chip) => {
    this.setState((prev) => {
      const next = { ...prev.draft };
      switch (chip.type) {
        case "names":
          next.names = [];
          break;
        case "country":
          next.country = null;
          break;
        case "role":
          next.roleId = null;
          break;
        case "branch":
          next.branchName = null;
          break;
        case "status":
          next.status = null;
          break;
        default:
          break;
      }
      return { draft: next };
    });
  };

  handleSearchCallback = (input1, input2, input3, input4, input5) => {
    let Name, Role, Country, Branch, Status;
    if (input1 === "yes") {
      Name = this.state.name;
      Role = this.state.role;
      Country = this.state.country;
      Branch = this.state.branch;
      Status = this.state.status;
    } else {
      Name = input1;
      Role = input3;
      Country = input2;
      Branch = input4;
      Status = input5;
      this.setState({
        search: "yes",
        name: Name,
        role: Role,
        country: Country,
        branch: Branch,
        status: Status,
      });
    }
    const data = {
      name: Name,
      role: Role,
      country: Country,
      branch: Branch,
      status: Status,
    };
    console.log(data);
    let currentPage = this.state.currentPage;
    let perPage = this.state.perPage;
    let url = `search/accounts`;
    search_ApiManager(
      url,
      data,
      currentPage,
      perPage,
      (res) => {
        console.log("search result", res);
        this.setState({
          allUsers: res.data.data["data"],
          totalItem: res.data.data["total"],
          perPage: res.data.data["per_page"],
          lastPage: res.data.data["last_page"],
          perItem: res.data.data["data"].length,
        });
      },
      (err) => {
        console.log(err);
      },
    );
  };

  render() {
    const role = JSON.parse(localStorage.getItem("user_role"));
    const rowStartIndex =
      this.state.currentPage * this.state.perPage - this.state.perPage + 1;

    const statusOptions = [
      { title: "Active", value: "Active" },
      { title: "Deactived", value: "Deactived" },
    ];

    const roleOptions = user_role.map((r) => ({
      id: r.value,
      name: r.title,
    }));

    const branchOptions = (this.state.allBranch || []).map((b) => ({
      id: b.agencyname,
      name: b.agencyname,
    }));

    const statusSelectOptions = statusOptions.map((s) => ({
      id: s.value,
      name: s.title,
    }));

    const canManageAccounts =
      this.state.allPermissions?.accounts === 1 || role === 2;

    if (!canManageAccounts) {
      return (
        <div className="tailwind-container">
          <div
            className={TASK_PAGE_SHELL_CLASS}
            style={MODULE_PAGE_SHELL_STYLE}
          >
            <div className="rounded-lg border border-red-200 bg-red-50 px-6 py-10 text-center text-sm text-red-600">
              You don&apos;t have permission to access this page.
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="tailwind-container">
        <div
          className={TASK_PAGE_SHELL_CLASS}
          style={MODULE_PAGE_SHELL_STYLE}
          aria-busy={this.state.loading}
        >
          <AccountsHeader onAddClick={this.handleOpenAddAccount} />

          <AddAccountModal
            open={this.state.showAddAccountModal}
            onClose={this.handleCloseAddAccount}
            onSuccess={this.handleAddAccountSuccess}
          />

          <EditAccountModal
            open={this.state.editAccountModal.open}
            userId={this.state.editAccountModal.userId}
            mode={this.state.editAccountModal.mode}
            onClose={this.handleCloseEditAccount}
            onSuccess={this.handleEditAccountSuccess}
          />

          <BulkIpModal
            open={this.state.showBulkIpModal}
            selectedCount={this.state.selectedUserIds.length}
            loading={this.state.bulkIpLoading}
            onClose={() => this.setState({ showBulkIpModal: false })}
            onSubmit={this.handleBulkIpModalSubmit}
          />

          <AccountsSearchFilters
            draft={this.state.draft}
            onDraftChange={this.handleDraftChange}
            participants={this.state.participants}
            roleOptions={roleOptions}
            branchOptions={branchOptions}
            statusOptions={statusSelectOptions}
            onApply={this.handleApplyFilters}
            onReset={this.handleResetFilters}
            onRemoveChip={this.handleRemoveFilterChip}
          />

          <BulkIpToolbar
            selectedCount={this.state.selectedUserIds.length}
            loading={this.state.bulkIpLoading}
            onEnable={this.handleBulkEnableIp}
            onDisable={this.handleBulkDisableIp}
            onManageIps={() => this.setState({ showBulkIpModal: true })}
            onClearIps={this.handleBulkClearIps}
            onClearSelection={this.handleClearUserSelection}
          />

          <div className="mt-3 overflow-hidden rounded-md border border-gray-200 bg-white shadow-sm">
            {this.state.loading ? (
              <AccountsTableSkeleton rows={10} />
            ) : (
              <AccountsTable
                users={this.state.allUsers}
                headers={this.state.headers}
                sortColumn={this.state.sortColumn}
                sortOrder={this.state.order}
                onSort={this.sorting}
                rowStartIndex={rowStartIndex}
                isTeamLeadUser={isTeamLeadUser}
                isActiveUser={isActiveUser}
                isHrAdminUser={isHrAdminUser}
                savingTeamLeadId={this.state.savingTeamLeadId}
                savingStatusId={this.state.savingStatusId}
                savingHrAdminId={this.state.savingHrAdminId}
                saving2faResetId={this.state.saving2faResetId}
                canManageTwoFactor={canManageAccounts}
                currentUserId={JSON.parse(localStorage.getItem("user_id") || "null")}
                onResetTwoFactor={this.handleResetTwoFactor}
                selectedUserIds={this.state.selectedUserIds}
                onToggleUser={this.handleToggleUserSelection}
                onToggleAll={this.handleToggleAllUsers}
                onToggleTeamLead={this.handleToggleTeamLead}
                onToggleStatus={this.handleToggleStatus}
                onToggleHrAdmin={this.handleToggleHrAdmin}
                onDeleteUser={this.deleteUser}
                onViewAccount={this.handleOpenViewAccount}
                onEditAccount={this.handleOpenEditAccount}
              />
            )}

            {!this.state.loading && this.state.totalItem > 0 && (
              <div className="border-t border-gray-100 px-2 py-1">
              <Paginations
                currentPage={this.state.currentPage}
                total={this.state.totalItem}
                itemsPerPage={this.state.perPage}
                lastPage={this.state.lastPage}
                totalItems={this.state.totalItem}
                perItem={this.state.perItem}
                onPageChange={this.handleCallback}
              />
              </div>
            )}
          </div>

          {role === 2 && !this.state.loading && (
            <AccountsExportBar
                    pdffilename={"Accounts.pdf"}
                    csvfilename={"Accounts.csv"}
                    xlsxfilename={"Accounts"}
                    header="Accounts List"
                    columns={this.state.headers}
                    data={this.state.allUsers}
                  />
          )}
                </div>
            </div>
    );
  }
}

export default ViewAccounts;
